import './style.scss';
import { ResultBody, ResultHeader } from 'views/mutual/result';
import { Caption } from 'views/mutual/caption';
import { Button, ButtonFill, ButtonSize } from 'views/mutual/button';
import { Description, labelColor, labelSize, alignTarget, alignType } from 'views/mutual/description';
import { PagePath, PagePathFactory } from 'constants/pagePath';
import { LeaseFundContractConfirmBody } from '../contractConfirm';
import { ContractDetailInfo } from 'views/utils/graphql/graphql';
import { useCustomLocationName } from 'views/mutual/location/hooks';
import { useNavigate } from 'react-router-dom';
import { ProductType, ProductTypeMap } from 'constants/productType';

type LeaseFundContractConfirmProps = {
  contractInfo: ContractDetailInfo;
  contractAgreementDocumentDownload: () => void;
};

export const LeaseFundContractComplete = ({ contractInfo, contractAgreementDocumentDownload }: LeaseFundContractConfirmProps) => {
  useCustomLocationName('契約締結完了');
  const navigate = useNavigate();

  return (
    <>
      <div className="contractComplete">
        <div className="contractComplete_descriptionWrapper">
          <Description
            label="契約締結をお申込みいただいた以下の案件について、お客様（新組合員）と、旧組合員（株式会社FPG）及び営業者との間で、ご契約が成立しました。"
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
            alignInfo={
              {
              target : alignTarget.desktop,
              type : alignType.center        
            }}
          />
          <Description
            label="支払日までに譲渡代金総額をお支払いいただきますようお願い申し上げます。"
            labelColor={labelColor.black}
            labelSize={labelSize.extraLarge}
          />
          <br/>
          <Description
            label={`お支払いに関する情報は振込依頼書にも記載しております。`}
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
          />
          <Description
            label={`振込依頼書は、交付書面 > ${
              ProductTypeMap[contractInfo.ProductType as ProductType]?.name
            } > 契約関連書面 からもご確認いただけます。`}
            labelColor={labelColor.gray}
            labelSize={labelSize.large}
          />
        </div>
        <Caption label="お申込内容" />
        <div className="contractComplete_wrapper">
          <LeaseFundContractConfirmBody contractInfo={contractInfo} />
        </div>
        <Caption label="振込先情報" />
        <div className="contractComplete_wrapper">
          <ResultHeader label="振込銀行" />
          <ResultBody label={contractInfo.PayeeBankName} />
          <ResultHeader label="支店名" />
          <ResultBody label={contractInfo.PayeeBankBranchName} />
          <ResultHeader label="口座" />
          <ResultBody label={contractInfo.PayeeBankAccountTypeName} />
          <ResultHeader label="口座番号" />
          <ResultBody label={contractInfo.PayeeBankAccount} />
          <ResultHeader label="口座名義" />
          <ResultBody
            label={`${contractInfo.PayeeBankAccountHolderName}（${contractInfo.PayeeBankAccountHolderNameKana}）`}
          />
        </div>
        <div className="contractComplete_wrapper">
          <Description
            label={`契約時交付書面を交付しました。`}
            labelColor={labelColor.red}
            labelSize={labelSize.large}
          />
          <Description
            label={`以下のボタンから交付書面にアクセスし、契約締結時交付書面を必ずご確認ください。`}
            labelColor={labelColor.red}
            labelSize={labelSize.large}
          />
        </div>
        <div className="contractComplete_wrapper">
          <Button
            label="交付書面"
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
            onClick={() => navigate(`${PagePath.IssuanceDocument}?id=0105${contractInfo.Symbol}`)}
          />
          <Button
            label="出資案件一覧へ"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.medium}
            onClick={() => navigate(PagePath.Position)}
          />
          <Button
            label="HOMEに戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.medium}
            onClick={() => navigate(PagePath.Home)}
          />
        </div>
      </div>
    </>
  );
};